import React, { Component } from "react";
import { flushSync } from "react-dom";
import { withTranslation, WithTranslation } from "react-i18next";
import { Button } from "devextreme-react";
import DateBox from "devextreme-react/date-box";
import LookupService, { LookupTypeIndexes } from "../../services/LookupService";
import sharedUtils from "../grid/sharedUtilities";
import DropDownFromLookupTableDynamic from "../select/SelectBoxFromLookupTableDynamic";
import { LookUpOnValueChangedEvent, SelectBoxOnValueChangedEvent } from "../../types/DevExtremeTypes";
import LookupTypeListDynamic from "../select/LookupTypeListDynamic";
import MatrixGridService from "../../services/MatrixService";

interface ProviderCalendarPageSidebarPanelProps extends WithTranslation {
    onApplyButtonClick: () => void;
    setServiceTypeId: (id: string) => void;
    setProviderId: (id: string) => void;
    setDateFrom: (date: Date) => void;
    serviceTypeId: string;
    dateFrom: Date | null;
    providerId: string;
}

class ProviderCalendarPageSidebarPanel extends Component<ProviderCalendarPageSidebarPanelProps> {
    lookupService: LookupService;
    sharedUtils: sharedUtils;
    matrixGridService: MatrixGridService;
    constructor(props: ProviderCalendarPageSidebarPanelProps) {
        super(props);
        this.lookupService = new LookupService();
        this.sharedUtils = new sharedUtils();
        this.matrixGridService = new MatrixGridService();
    }
    handleChangeProviderTypeSelect = (e: LookUpOnValueChangedEvent) => {
        this.props.setProviderId(e.value);
    };

    handleChangeServiceTypeSelect = (e: SelectBoxOnValueChangedEvent) => {
        this.props.setServiceTypeId(e.value);
    };

    handleChangeDateFrom = (e: any) => {
        flushSync(() => {
            this.props.setDateFrom(e.value);
        });
    };

    onApplyButtonClicked = () => {
        this.props.onApplyButtonClick();
    };

    render() {
        let disableApplyButton = false;
        if (!this.props.providerId) {
            disableApplyButton = true;
        }
        if (!this.props.serviceTypeId) {
            disableApplyButton = true;
        }
        return (
            <div>
                <div className="row mt-4">
                    <div className="col-10">
                        <h4 className="sidebar__heading font-weight-bold">Filter spend</h4>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col sidebar__heading">Provider</div>
                </div>
                <div className="row mt-2">
                    <div className="col">
                        <LookupTypeListDynamic
                            lookupTypeIndex={LookupTypeIndexes.providerType}
                            onValueChanged={this.handleChangeProviderTypeSelect}
                            isRoot={false}
                            parentMappingId={""}
                            displayExpression={"value"}
                            value={this.props.providerId}
                            recordType={"all"}
                            isDisabled={false}
                        />
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col sidebar__heading">Service</div>
                </div>
                <div className="row mt-2">
                    <div className="col">
                        <DropDownFromLookupTableDynamic
                            lookupTypeIndex={LookupTypeIndexes.serviceType}
                            isRoot={true}
                            parentMappingId={"0"}
                            onValueChanged={this.handleChangeServiceTypeSelect}
                            isDisabled={false}
                            value={this.props.serviceTypeId}
                        />
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col sidebar__heading">Date From</div>
                </div>
                <div className="row mt-2">
                    <div className="col">
                        <DateBox
                            value={this.props.dateFrom || undefined}
                            onValueChanged={this.handleChangeDateFrom}
                            displayFormat="dd/MM/yyyy"
                            useMaskBehavior={true}
                        />
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-6 mx-auto">
                        <Button
                            className="btn btn-primary btn--large"
                            onClick={this.onApplyButtonClicked}
                            disabled={disableApplyButton}
                        >
                            Apply
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(ProviderCalendarPageSidebarPanel);
